import { Action, createReducer, on } from '@ngrx/store';
import { Status } from '../../../models/status';
import {
  initializeCardOnFileServiceState,
  loadCardsOnFile,
  loadCardsOnFileLookupComplete,
  resetCardsOnFile,
  setSelectedCardOnFile,
} from './card-on-file-service.actions';
import { cardsOnFileAdapter, initialCardOnFileServiceState } from './card-on-file-service.state';

const featureReducer = createReducer(
  initialCardOnFileServiceState,

  // Get cards on file by MP numbers
  on(loadCardsOnFile, (state) => {
    return {
      ...state,
      cardOnFileLookupByMPNumbers: {
        ...state.cardOnFileLookupByMPNumbers,
        status: Status.LOADING,
        cardsOnFileSuccess: true,
      },
    };
  }),
  on(resetCardsOnFile, (state) => ({
    ...state,
    cardOnFileLookupByMPNumbers: {
      cardsOnFile: cardsOnFileAdapter.removeAll(state.cardOnFileLookupByMPNumbers.cardsOnFile),
      status: Status.LOADING,
      cardsOnFileSuccess: true,
    },
    selectedCardOnFile: null,
  })),
  on(loadCardsOnFileLookupComplete, (state, { cardsOnFile, success }) => {
    return {
      ...state,
      cardOnFileLookupByMPNumbers: {
        cardsOnFile:
          cardsOnFile && cardsOnFile.length > 0
            ? cardsOnFileAdapter.setAll(cardsOnFile, state.cardOnFileLookupByMPNumbers.cardsOnFile)
            : state.cardOnFileLookupByMPNumbers.cardsOnFile,
        cardsOnFileSuccess: success,
        status: Status.STABLE,
      },
      selectedCardOnFile: null,
    };
  }),
  on(setSelectedCardOnFile, (state, { selectedCardOnFile }) => ({
    ...state,
    selectedCardOnFile,
  })),
  on(initializeCardOnFileServiceState, (state) => ({ ...state, ...initialCardOnFileServiceState }))
);

export function cardOnFileServiceReducer(state = initialCardOnFileServiceState, action: Action) {
  return featureReducer(state, action);
}
